import { createRoot } from "react-dom/client";
import { StoreProvider } from "@/app/storeProvider";
import React from "react";
import HouseCompetition from "../app/(custom-header)/prizes/house-v2/page";

const root = createRoot(document.getElementById("house-page-v2") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <HouseCompetition />
    </StoreProvider>
  </React.StrictMode>
);
